import { render, staticRenderFns } from "./WallScheduleBlockGeneralSettings.vue?vue&type=template&id=2d44ee1c"
import script from "./WallScheduleBlockGeneralSettings.vue?vue&type=script&lang=js"
export * from "./WallScheduleBlockGeneralSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports